function initializeGalleryClickHandlers() {
  const galleryBlocks = document.querySelectorAll('.gallery-block');
  
  galleryBlocks.forEach(function(block) {
    try {
      if (block.dataset.galleryClickInit === 'true') {
        return;
      }
      
      const buttonLink = block.querySelector('.text-overlay__buttons a[href]');
      if (!buttonLink) {
        return;
      }
      
      const href = buttonLink.getAttribute('href');
      const mediaDiv = block.querySelector('.gallery-block__image');
      
      if (!mediaDiv) {
        return;
      }
      
      if (block.tagName === 'A') {
        block.dataset.galleryClickInit = 'true';
        return;
      }
      
      const hotspots = block.querySelectorAll('.hotspot');
      if (hotspots.length > 0) {
        block.dataset.galleryClickInit = 'true';
        return;
      }
      
      mediaDiv.style.cursor = 'pointer';
      mediaDiv.addEventListener('click', function(e) {
        if (e.target !== buttonLink && !buttonLink.contains(e.target)) {
          window.location.href = href;
        }
      });
      
      block.dataset.galleryClickInit = 'true';
    } catch (error) {
      console.error('Error processing gallery block:', error);
    }
  });
}

document.addEventListener('DOMContentLoaded', initializeGalleryClickHandlers);


if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initializeGalleryClickHandlers);
}